import React, { useState, useEffect, useRef } from "react"
import Link from "next/link"
import { Layout } from "components/common"
import { Loading } from "components/ui"
import "react-datepicker/dist/react-datepicker.css"
import { trackGA } from "lib/func"
import Cookies from "js-cookie"
import { useRouter } from "next/router"
import { apiLiveScore } from "api"
import BoxTimeLiveScore from "components/BoxTimeLiveScore"
import classNames from "classnames"
import { renderHoursChanel } from "utils/time"
import useStore from "components/ui/Context"
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"

function convertTime(_date) {
  const timezone = Math.abs(_date.getTimezoneOffset() / 60)
  const m = _date.getMonth() + 1
  const date = _date.getFullYear() + "-" + m + "-" + _date.getDate()
  return { timezone, date }
}

function formatDate(time) {
  let date = new Date(time)
  let day = date.getDate().toString().padStart(2, "0")
  let month = (date.getMonth() + 1).toString().padStart(2, "0")
  let year = date.getFullYear()
  return `${day}/${month}/${year}`
}

function compareDate(item) {
  if (!item?.start) return null
  let today = new Date().toISOString().split("T")[0]
  let itemDate = new Date(item.start).toISOString().split("T")[0]

  return today === itemDate ? "Hôm nay" : formatDate(item.start)
}

export default function LiveScore() {
  const router = useRouter()
  const [rows, setRows] = useState([])
  const [categories, setCategories] = useState([])
  const [activeCategory, setActiveCategory] = useState(null)
  const [loading, setLoading] = useState(false)
  const __list = useRef([])
  const btnRefs = useRef([])
  const setModalLive = useStore().setModalLive

  const isPastEvent = (startTime) => {
    const now = new Date()
    const eventDate = new Date(startTime)
    return eventDate < now
  }

  function nextPath(item) {
    if (item?.status !== "live") {
      setModalLive({
        show: true,
        isVod: false,
        info: {
          status: item?.status,
          title: item?.name,
          start_time: item?.start
        }
      })
    } else {
      router.push(`/video?id=${item?.event_id}&type=0`)
    }
  }

  async function fetch(date, category_id) {
    Cookies.set("date", date, { expires: 1 })
    try {
      setLoading(true)
      const { data } = await apiLiveScore.getLiveScores({ ...convertTime(date), category_id })
      if (data?.length > 0) {
        __list.current = data
        setRows(data)
      } else {
        __list.current = data
        setRows([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchCategories = async () => {
    try {
      setLoading(true)
      const { data } = await apiLiveScore.getCategories()
      if (data?.length > 0) {
        setCategories(data)
      } else {
        setCategories([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  async function renderLink(e, video) {
    e.stopPropagation()
    // if (isMobile || isTablet) {
    const { type, id, videos, status } = video
    try {
      const params = {
        type: status === "live" ? type : videos[0].type,
        id: status === "live" ? id : videos[0].id
      }
      router.push(`/video?id=${params.id}&type=${params.type}`)
      // const { data } = await apiLiveScore.getLink(params)
      // window.open(data)
    } catch (error) {
      console.log(error)
    }
    // } else {
    //   setVisible(true)
    // }
  }

  useEffect(() => {
    const date = Cookies.get("date")
    const __d = date ? new Date(date) : new Date()
    fetch(__d, activeCategory)
    trackGA("Livescores", "LIVESCORES_TAB")
  }, [activeCategory])

  useEffect(() => {
    fetchCategories()
  }, [])

  useEffect(() => {
    checkScoreWin()
  }, [rows])

  function checkScoreWin() {
    const scoreTeam1s = Array.from(document.querySelectorAll(".score__team1"))
    const scoreTeam2s = Array.from(document.querySelectorAll(".score__team2"))

    scoreTeam1s.forEach((scoreTeam1, index) => {
      const score2 = parseInt(scoreTeam2s[index].innerHTML) || 0
      const score1 = parseInt(scoreTeam1.innerHTML) || 0

      scoreTeam1.style.color = "#fff"
      scoreTeam2s[index].style.color = "#fff"

      if (score1 > score2) {
        scoreTeam1.style.color = "#1877F2"
      } else if (score1 === score2) {
        scoreTeam1.style.color = "#fff"
        scoreTeam2s[index].style.color = "#fff"
      } else {
        scoreTeam2s[index].style.color = "#1877F2"
      }
    })
  }

  let isDragging = false
  let startX

  function handleDragStart(e) {
    e.preventDefault()
    isDragging = true
    startX = e.pageX || e.touches[0].pageX
  }

  function handleDrag(e) {
    if (!isDragging) return
    const x = e.pageX || e.touches[0].pageX
    const scrollLeft = e.currentTarget.scrollLeft
    e.currentTarget.scrollLeft = scrollLeft - (x - startX)
    startX = x
  }

  function handleDragEnd() {
    isDragging = false
  }

  function handleClick(tab, index) {
    setActiveCategory(tab)
    if (index) {
      btnRefs.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      })
    }
  }

  return (
    <main className="flex justify-center">
      <div className="relative max-w-[1042px] mb-[90px] px-4 w-full">
        <Loading loading={loading}>
          <BoxTimeLiveScore fetch={fetch} activeCategory={activeCategory} />
          <div
            className="list-game-container draggable flex items-center gap-2 font-bold mt-6 sticky top-[58.75px] xl:top-[83.75px] z-30 bg-[#131313] py-2 max-sm:mt-2"
            onMouseDown={(e) => handleDragStart(e)}
            onMouseMove={(e) => handleDrag(e)}
            onMouseUp={() => handleDragEnd()}
            onMouseLeave={() => handleDragEnd()}
          >
            <button
              className={classNames(
                "flex items-center justify-center list-game__background rounded-[44px] text-lg leading-6 font-medium py-2 px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                {
                  "list-game__background--active": activeCategory === null
                }
              )}
              onClick={() => handleClick(null)}
            >
              {activeCategory === null ? (
                <img src="/icons/iconDocumentBlue.svg" />
              ) : (
                <img src="/icons/iconDocument.svg" />
              )}
              <span className={" " + activeCategory != null && "max-sm:hidden max-lg:text-[16px] "}>Tất cả</span>
            </button>
            {categories
              .sort(function (a, b) {
                return a.name.localeCompare(b.name)
              })
              .map((category, index) => (
                <button
                  className={classNames(
                    "flex items-center justify-center list-game__background rounded-[44px] text-lg leading-6 font-medium py-[2px] px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                    {
                      "list-game__background--active": activeCategory === category?.id
                    }
                  )}
                  key={category?.id}
                  ref={(el) => (btnRefs.current[index] = el)}
                  onClick={() => handleClick(category?.id, index)}
                >
                  <img
                    src={activeCategory === category?.id ? category?.logo_active : category?.logo_inactive}
                    width={36}
                    height={36}
                  />
                  <span className={activeCategory != category?.id && "max-sm:hidden max-lg:text-[16px] "}>
                    {category?.name}
                  </span>
                </button>
              ))}
          </div>

          <div className="mt-8 max-sm:mt-2">
            <div className="flex flex-col gap-3">
              {rows?.length > 0
                ? rows?.map((item, k) => {
                    const isPast = isPastEvent(item?.start)
                    return (
                      <div key={k}>
                        {item?.livescore_type === 1 && (
                          <div className="flex flex-col rounded-xl overflow-hidden">
                            <div
                              className={`flex items-center rounded-xl bg-[#232323] p-4 ${
                                isPast ? "cursor-auto" : "cursor-pointer"
                              }`}
                              onClick={() => nextPath(item)}
                            >
                              <div className="flex flex-col gap-3 w-full">
                                <div className="flex gap-2 bg-[#1A1A1A] p-4 rounded-lg justify-between items-center">
                                  <div className="flex gap-2">
                                    <Link href={`/league?id=${item?.league?.id}`} onClick={(e) => e.stopPropagation()}>
                                      <div className="fix_img">
                                        <img src={item?.league?.logo} alt="" width={44} height={44} />
                                      </div>
                                    </Link>
                                    <div className="flex flex-col gap-[1px] justify-center">
                                      <Link
                                        href={`/league?id=${item?.league?.id}`}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <Tippy content={item?.league?.name}>
                                          <div className="text-base leading-6 font-medium items-center text-left gap-1 line-clamp-1">
                                            {item?.league?.name}
                                          </div>
                                        </Tippy>
                                      </Link>
                                      <Link
                                        href={`/category?id=${item?.category?.id}`}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <button className="text-base leading-5 text-left font-normal text-[#888888] line-clamp-1">
                                          {item?.category?.name}
                                        </button>
                                      </Link>
                                    </div>
                                  </div>
                                  {item?.status === "live" && (
                                    <div className="flex gap-1 bg-[#d1242a] items-center pl-1.5 rounded-full cursor-pointer">
                                      <div className="text-[#FAFAF9] font-bold text-sm leading-[14.4px]">LIVE</div>
                                      <img src="/icons/iconPlayLive.svg" />
                                    </div>
                                  )}
                                </div>
                                {item?.status === "finish" ? (
                                  item?.detail?.top1_team && item?.detail?.top2_team && item?.detail?.top3_team ? (
                                    <div className="flex gap-3 w-full pt-1.5 pb-2">
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon1st.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">
                                          {item?.detail?.top1_team}
                                        </span>
                                      </div>
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon2nd.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">
                                          {item?.detail?.top2_team}
                                        </span>
                                      </div>
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon3rd.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">
                                          {item?.detail?.top3_team}
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="flex gap-3 w-full pt-1.5 pb-2">
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon1st.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">-</span>
                                      </div>
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon2nd.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">-</span>
                                      </div>
                                      <div className="flex flex-col basis-1/3 gap-1.5 items-center">
                                        <img src="/icons/icon3rd.svg" />
                                        <span className="text-base leading-6 font-medium text-[#fafaf9]">-</span>
                                      </div>
                                    </div>
                                  )
                                ) : (
                                  <div className="flex justify-between px-2 gap-3 py-2 w-full">
                                    <div className="flex flex-col gap-3 justify-between text-base leading-6 font-medium text-[#fafaf9]">
                                      <span>Số đội thi đấu</span>
                                      <div className="flex gap-2">
                                        <img src="/icons/iconPeopleAudience.svg" />
                                        {item?.detail?.number_of_teams}
                                      </div>
                                    </div>
                                    {item?.status === "live" ? (
                                      <div className="flex flex-col gap-3 justify-between text-base leading-6 font-medium text-[#fafaf9]">
                                        <span>Số trận</span>
                                        <div className="flex justify-end gap-2">
                                          <img src="/icons/iconGame.svg" />
                                          {item?.detail?.number_of_matches}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="flex flex-col gap-3 justify-between text-base leading-6 font-medium text-[#fafaf9]">
                                        <span>{compareDate(item)}</span>
                                        <span className="text-right">{renderHoursChanel(item?.start)}</span>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {item?.livescore_type === 0 && (
                          <div
                            className={`flex items-center rounded-xl bg-[#232323] p-4 max-sm:p-3 gap-3 ${
                              isPast ? "cursor-auto" : "cursor-pointer"
                            }`}
                            onClick={() => nextPath(item)}
                          >
                            <div className="flex flex-col gap-3 w-full">
                              <div className="flex gap-3.5 bg-[#1a1a1a] p-4 max-sm:p-2 rounded-lg justify-between items-center">
                                <div className="flex gap-2">
                                  <Link href={`/league?id=${item?.league?.id}`} onClick={(e) => e.stopPropagation()}>
                                    <div className="fix_img max-sm:flex justify-center items-center">
                                      <img
                                        className="max-sm:object-cover max-sm:max-w-[32px] max-sm:max-h-[32px]"
                                        src={item?.league?.logo}
                                        width={44}
                                        height={44}
                                      />
                                    </div>
                                  </Link>
                                  <div className="flex flex-col gap-[1px] justify-center">
                                    <Link href={`/league?id=${item?.league?.id}`} onClick={(e) => e.stopPropagation()}>
                                      <Tippy content={item?.league?.name}>
                                        <div
                                          className="text-base leading-6 font-medium text-[#fafaf9] flex items-center gap-1 max-sm:text-[14px]"
                                          style={{ display: "flex", justifyContent: "center" }}
                                        >
                                          <span className="max-sm:line-clamp-1">{`${item?.league?.name}  •  ${item?.name}`}</span>
                                        </div>
                                      </Tippy>
                                    </Link>
                                    <Link
                                      href={`/category?id=${item?.category?.id}`}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <button className="text-base leading-5 font-normal text-[#888888] max-sm:text-xs">
                                        {item?.category?.name}
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                                {item?.status === "live" && (
                                  <div className="flex gap-1 bg-[#d1242a] items-center pl-1.5 rounded-full cursor-pointer">
                                    <div className="text-[#fafaf9] font-bold text-sm leading-[14.4px]">LIVE</div>
                                    <img src="/icons/iconPlayLive.svg" />
                                  </div>
                                )}
                              </div>
                              <div className="flex flex-col gap-3 w-full">
                                <div className="flex justify-between px-2 py-1">
                                  <div className="flex gap-2 items-center">
                                    <Tippy content={item?.detail?.home_name}>
                                      <img
                                        className="max-sm:w-[20px] max-sm:h-[20px]"
                                        src={item?.detail?.home_thumbnail}
                                        alt=""
                                        width={24}
                                        height={24}
                                      />
                                    </Tippy>
                                    <div className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {item?.detail?.home_name}
                                    </div>
                                  </div>
                                  {item?.detail?.home_score ? (
                                    <span className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {item?.detail?.home_score}
                                    </span>
                                  ) : item?.status === "live" ? (
                                    <span className="text-sm font-bold">-</span>
                                  ) : (
                                    <span className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {compareDate(item)}
                                    </span>
                                  )}
                                </div>
                                <div className="flex justify-between px-2 py-1">
                                  <div className="flex gap-2 items-center">
                                    <Tippy content={item?.detail?.away_name}>
                                      <img
                                        className="max-sm:w-[20px] max-sm:h-[20px]"
                                        src={item?.detail?.away_thumbnail}
                                        alt=""
                                        width={24}
                                        height={24}
                                      />
                                    </Tippy>
                                    <div className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {item?.detail?.away_name}
                                    </div>
                                  </div>
                                  {item?.detail?.away_score ? (
                                    <span className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {item?.detail?.away_score}
                                    </span>
                                  ) : item?.status === "live" ? (
                                    <span className="text-sm font-bold">-</span>
                                  ) : (
                                    <span className="text-base leading-6 font-medium text-[#fafaf9] max-sm:text-[14px]">
                                      {renderHoursChanel(item?.start)}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  })
                : !loading && (
                    <div className="flex text-center justify-center mt-[90px]">
                      <div className="flex flex-col w-[312px] items-center">
                        <img src="/noMatch.svg" className="w-[250px] max-sm:w-[120px]" alt="" />
                        <div className="flex flex-col gap-2 text-center">
                          <span className="text-[22px] leading-[30px] font-semibold text-[#FAFAF9]">
                            Chưa có lịch thi đấu
                          </span>
                          <span className="text-base leading-5 font-normal text-[#C6C6C8]">
                            Chúng tôi đang cập nhật nội dung này. Bạn có thể thử lại sau một thời gian nữa.
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </Loading>
      </div>
    </main>
  )
}

LiveScore.Layout = Layout
